import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import he from './locales/he.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: en,
      },
      he: {
        translation: he,
      },
    },
    fallbackLng: 'he', // Default to Hebrew
    lng: localStorage.getItem('greenar_language') || 'he',
    interpolation: {
      escapeValue: false,
    },
  });

// Set initial direction
if (typeof window !== 'undefined') {
  const lang = i18n.language || 'he';
  document.documentElement.dir = lang === 'he' ? 'rtl' : 'ltr';
  document.documentElement.lang = lang;
}

export default i18n;
